import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Cookie consent storage key
const COOKIE_CONSENT_KEY = 'ph-therapy-cookie-consent';

type ConsentStatus = 'pending' | 'accepted' | 'declined';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY) as ConsentStatus | null;
    if (stored !== 'accepted' && stored !== 'declined') {
      setVisible(true);
    }
  }, [mounted]);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
    // TODO (Step 8): Load Google Analytics or other tracking here
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-labelledby="cookie-banner-title" aria-describedby="cookie-banner-desc">
      <div className="cookie-banner-inner">
        <div className="cookie-banner-content">
          <h2 id="cookie-banner-title" className="cookie-banner-title">We use cookies</h2>
          <p id="cookie-banner-desc" className="cookie-banner-desc">
            We use cookies to improve your experience and analyse site traffic. See our{' '}
            <Link to="/privacy">Privacy Policy</Link> for details.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button type="button" className="cookie-banner-btn cookie-banner-btn--decline" onClick={handleDecline}>
            Decline
          </button>
          <button type="button" className="cookie-banner-btn cookie-banner-btn--accept" onClick={handleAccept}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
